import { Injectable } from '@angular/core';
import { RestService } from './_rest.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends RestService{

  init(){
    this.endpoint = 'users';
    this.modelname = 'user';
    }
}
 